import React, { useState, useEffect } from 'react';
import { Button, Balloon } from '@alifd/next';
import { history } from 'ice';
import { Servlets } from '@/service';
import styles from './index.module.scss';
import yinru from '@/assets/images/AutoMarketing/yinru.png';
import chengzhang from '@/assets/images/AutoMarketing/chengzhang.png';
import chengshu from '@/assets/images/AutoMarketing/chengshu.png';
import xiumian from '@/assets/images/AutoMarketing/xiumian.png';

const MarketingCreateActivity = () => {
  // 模型列表
  const [modelList, setModelList] = useState([]);
  // 弹层
  // const { Popup } = Overlay;
  const { Tooltip } = Balloon;

  /**
   * 判断当前
   */
  const dealActivityType = (modelType) => {
    if (modelType === 1) {
      return 'custom';
    } else if (modelType === 2) {
      return 'private';
    }
  };

  /**
   * @description: 点击去创建活动的按钮，判断不同modelId做不同处理 (1和6为所有商家可见，但只提供给开白商家使用)
   * @param {*} item 当前模型所有信息
   * @return {*}
   */
  const createActivity = (item) => {
    // 根据 modelId 跳转不同的路由
    // PrivateService.checkModelWhite({ modelId: item.viewButton.modelId })
    //   .then((res) => {
    //     if (res.data) {
          // if (item.viewButton.modelId === 1) {
          //   // 宝洁模型
          //   history.push(
          //     '/smsautomarket/marketing/autoMarketing/daily/membership/notpurchase/create',
          //     { checkType: 1, data: item }
          //   );
          // } else if (item.viewButton.modelId === 2) {
          //   // 联合利华模型
          //   history.push(
          //     '/smsautomarket/marketing/automarket/member/first/purchase/create',
          //     { checkType: 1, data: item }
          //   );
          // } else
          if (item.viewButton.modelId === 6) {
            // 复购模型利华模型
            history.push('/smsautomarket/marketing/cycleCreate', {
              checkType: 1,
              data: item,
            });
          } else {
            history.push('/smsautomarket/marketing/create', {
              checkType: 1,
              data: item,
            });
          }
        // } else {
        //   history.push('/smsautomarket/marketing/create', {
        //     checkType: 1,
        //     data: item,
        //   });
        // }
      // })
      // .catch((e) => {
      //   console.log(e);
      // });
  };

  useEffect(() => {
    parent.scrollTo(0, 0);
    document.body.scrollTop = 0;
    // Servlets('getAutoMarketList', {})
    //   .then((res) => {
      const  res = {
    "data": [
        {
            "parentLevelId": 0,
            "modelType": 3,
            "modelTypeName": "专属定制模型",
            "picture": "",
            "colour": null,
            "orderBy": 1,
            "subLevel": [
                {
                    "parentLevelId": 3,
                    "modelType": 3001,
                    "modelTypeName": "引入期",
                    "picture": "yinru",
                    "colour": "#FFAAAA/linear-gradient(149deg, #FF9233 0%, #FF3333 100%)",
                    "orderBy": 1,
                    "subLevel": [],
                    "modelList": [
                        {
                            "modelId": 6,
                            "modelType": 3001,
                            "activityName": "复购模型",
                            "activityDescription": "通过客户在店铺内的实际下单情况，进行用户下一次购买时间预估，在预估时间点进行短信触达，提高客户复购率",
                            "viewButton": {
                                "modelId": 6,
                                "firstHalf": [
                                    {
                                        "select": true,
                                        "crowdDesc": "按产品线录入",
                                        "crowdName": "按产品线录入",
                                        "crowdSubId": 1
                                    },
                                    {
                                        "select": false,
                                        "crowdDesc": "按SKU线录入",
                                        "crowdName": "按SKU线录入",
                                        "crowdSubId": 2
                                    }
                                ],
                                "secondHalf": {
                                    "addParam": {
                                        "skuList": [
                                            {
                                                "day": "1",
                                                "skuId": "1"
                                            },
                                            {
                                                "day": "1",
                                                "skuId": "2"
                                            },
                                            {
                                                "day": "1",
                                                "skuId": "3"
                                            },
                                            {
                                                "day": "2",
                                                "skuId": "4"
                                            },
                                            {
                                                "day": "2",
                                                "skuId": "5"
                                            }
                                        ]
                                    },
                                    "subShopId": null
                                }
                            },
                            "openStatus": 7
                        }
                    ]
                }
            ],
            "modelList": []
        }
    ],
    "resp_code": 0,
    "resp_msg": "",
    "success": true
}
        setModelList(res.data);
      // })
      // .catch((e) => {
      //   console.log(e);
      // });
  }, []);

  return (
    <div className={`${styles.content} marketing-create-activity`}>
      {modelList.map((val, valIndex) =>
        val.subLevel.length !== 0 ? (
          <div className={styles.modelBox} key={valIndex}>
            {/* 会员营销模型标题  */}
            <div style={{ display: 'flex', marginBottom: '30px' }}>
              <div
                style={{
                  width: 3,
                  height: 16,
                  backgroundColor: '#3399FF',
                  marginRight: '8px',
                }}
              />
              <div
                style={{ fontSize: '16px', height: '16px', lineHeight: '16px' }}
              >
                {val.modelTypeName}
              </div>
            </div>
            <div>
              {val.subLevel.map((outlay, outindex) => {
                return outlay.modelList.length !== 0 ? (
                  <div style={{ display: 'flex' }} key={val?.modelId}>
                    {+val.modelType !== 3 ? (
                      <div
                        style={{
                          width: '10px',
                          position: 'relative',
                          background: '#E8EAF1',
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: '-5px',
                            width: '20px',
                            height: '20px',
                            background: 'white',
                            borderRadius: '50%',
                            border: `4px solid ${outlay.colour.split('/')[0]}`,
                          }}
                        />
                      </div>
                    ) : (
                      ''
                    )}

                    <div style={{width: '100%'}}>
                      {+val.modelType !== 3 ? (
                        <div
                          style={{
                            fontSize: '26px',
                            fontWeight: 600,
                            marginLeft: '30px',
                            marginBottom: '10px',
                            display: 'flex',
                          }}
                        >
                          <div style={{ marginRight: '10px' }}>
                            <img
                              src={
                                outlay.picture === 'yinru'
                                  ? yinru
                                  : outlay.picture === 'chengzhang'
                                  ? chengzhang
                                  : outlay.picture === 'chengshu'
                                  ? chengshu
                                  : outlay.picture === 'xiumian'
                                  ? xiumian
                                  : ''
                              }
                              alt=""
                            />
                          </div>
                          <div>{outlay.modelTypeName}</div>
                        </div>
                      ) : (
                        ''
                      )}

                      <div
                        className={` ${styles['card-box']}`}
                        style={{
                          flexWrap: 'wrap',
                          padding: '0px 0px 20px 20px',
                          flex: 1,
                          position: 'relative',
                        }}
                      >
                        {outlay.modelList.map((item, index) => {
                          return (
                            <div key={index} className={styles.box}>
                              <div
                                style={{
                                  height: '10px',
                                  background: `${outlay.colour.split('/')[0]}`,
                                  width: '100%',
                                  paddingTop: '10px',
                                  position: 'relative',
                                }}
                              >
                                <div
                                  style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                    visibility: item.openStatus === null ? 'hidden' : 'visible',
                                  }}
                                >
                                  {/* {item.openStatus > 0 ? ( */}
                                   {/*  <div
                                      style={{
                                        background: '#F5605D',
                                        width: '70px',
                                        height: '20px',
                                        color: '#ffffff',
                                        lineHeight: '20px',
                                        fontSize: '12px',
                                        borderRadius: '0 0 0 10px',
                                        paddingLeft: '3px',
                                      }}
                                    >
                                      <span
                                        style={{
                                          marginLeft: '8px',
                                          fontSize: '12px',
                                        }}
                                      >{`进行中 ${item.openStatus}`}</span>
                                    </div> */}
                                  {/* // ) : (
                                  //   <div
                                  //     style={{
                                  //       background: '#BCBBBB',
                                  //       width: '70px',
                                  //       height: '20px',
                                  //       color: '#ffffff',
                                  //       lineHeight: '20px',
                                  //       fontSize: '12px',
                                  //       borderRadius: '0 0 0 10px',
                                  //       paddingLeft: '8px',
                                  //     }}
                                  //   >
                                  //     <span
                                  //       style={{
                                  //         marginLeft: '8px',
                                  //         fontSize: '12px',
                                  //       }}
                                  //     >
                                  //       未开启
                                  //     </span>
                                  //   </div>
                                  // )} */}
                                </div>
                              </div>
                              <div
                                style={{
                                  width: '100%',
                                  fontSize: '16px',
                                  fontFamily: 'PingFang SC',
                                  fontWeight: 'bold',
                                  height: '26px',
                                  lineHeight: '16px',
                                  padding: '20px',
                                }}
                              >
                                {item.activityName}
                              </div>

                              <div
                                style={{
                                  width: '100%',
                                  fontSize: '12px',
                                  color: '#657180',
                                  height: '36px',
                                  padding: '10px 20px 0px 20px',
                                }}
                              >
                                <Tooltip
                                  align="t"
                                  alignEdge
                                  closable={false}
                                  style={{
                                    color: '#9ca7b6',
                                    paddingLeft: '5px',
                                  }}
                                  trigger={
                                    <span className={styles.modelContent}>
                                      {item.activityDescription}
                                    </span>
                                  }
                                >
                                  <div
                                    style={{
                                      width: '200px',
                                    //   height: '60px',
                                      padding: '0px 0px 10px 10px',
                                      textAlign: 'justify',
                                    }}
                                  >
                                    {item.activityDescription}
                                  </div>
                                </Tooltip>
                              </div>
                              <div
                                style={{
                                  width: '100%',
                                  fontSize: '12px',
                                  display: 'flex',
                                  height: '28px',
                                  padding: '0 20px 20px 20px',
                                  marginBottom: '10px',
                                }}
                                className={styles.boxBottom}
                              >
                                <div style={{ flex: '1' }} />
                                <div style={{ flex: '1', textAlign: 'right' }}>
                                  {
                                    item.modelId === null ? (
                                      <Balloon.Tooltip
                                        v2
                                        className='not-background-tooltip'
                                        align="t"
                                        trigger={
                                          <Button
                                          type="primary"
                                          style={{
                                            width: '78px',
                                            height: '26px',
                                            padding: '0px',
                                            background: `${outlay.colour.split('/')[1]}`,
                                          }}
                                          className={styles.btn}
                                          onClick={() => createActivity(item)}
                                        >
                                          {item?.btnText ?? '去创建活动'}
                                        </Button>
                                        }
                                      >
                                        <img src="https://s3.cn-north-1.jdcloud-oss.com/lz-marketing/media/qrcode.svg" alt="定制专属交易数据咨询二维码" style={{ width: 148 }} />
                                      </Balloon.Tooltip>
                                    ) : <Button
                                      type="primary"
                                      style={{
                                        width: '78px',
                                        height: '26px',
                                        padding: '0px',
                                        background: `${outlay.colour.split('/')[1]}`,
                                      }}
                                      className={styles.btn}
                                      onClick={() => createActivity(item)}
                                    >
                                      {item?.btnText ?? '去创建活动'}
                                    </Button>
                                  }
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                );
              })}
            </div>
          </div>
        ) : (
          ''
        )
      )}
    </div>
  );
};

export default MarketingCreateActivity;
